// extracted by mini-css-extract-plugin
module.exports = {"PasswordChange":"PasswordChange_PasswordChange__25TGc"};